import React from 'react'

import { ActiveSource, Source, SourceTable } from 'types/GlobalSource'

import Text from 'components_new/atoms/Text'

import SourceDataTable from 'components_new/organisms/internal/sources/SourceDataTable'
import SourceEndpoints from 'components_new/organisms/internal/sources/SourceEndpoints'
import SourceUpload from 'components_new/organisms/internal/sources/SourceUpload'

import { ESourceTab } from 'utils/sources'

interface SourceTabContentProps {
  activeSource: ActiveSource
  activeTable: SourceTable | null
  source: Source
  tab: ESourceTab
}

const SourceTabContent = (props: SourceTabContentProps) => {
  const { activeSource, activeTable, source, tab } = props

  if (source.attributes.type === 'KPI_API') {
    return (
      <Text variant="subtitle2">
        Den här källan har ingen data som kan visas, den hämtar data direkt vid
        hämtning av mätetalen. Och går således inte att aktivera eller skanna på
        samma sätt som andra källor.
      </Text>
    )
  }

  switch (tab) {
  case ESourceTab.ENDPOINTS:
    return <SourceEndpoints activeSource={activeSource} source={source} />
  case ESourceTab.UPLOAD:
    return <SourceUpload activeSource={activeSource} />
  default:
    return (
      <SourceDataTable
        activeSource={activeSource}
        activeTable={activeTable}
        source={source}
      />
    )
  }
}

export default SourceTabContent
